<template>
  <v-dialog v-model="showAssignModule" persistent max-width="600px">
    <AddEditGroupsDialog
      ref="addEditGroupInDialog"
      @changeEvent="doneNewGroup"
    />
    <v-card>
      <v-card-title class="headline grey lighten-3">
        <span class="headline">
          <v-icon class="mr-2">fal fa-book</v-icon>Assign Module to User(s) or
          Group(s)
        </span>
        <v-spacer></v-spacer>
        <button
          type="button"
          class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
          :disabled="isLoading"
          @click="close"
        >
          <i class="fal fa-times"></i>
        </button>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="assign.module_id"
                :items="modules"
                item-value="id"
                item-text="name"
                :menu-props="{ closeOnClick: true }"
                label="Select Module by typing the name..."
                :search-input.sync="searchModules"
                hide-no-data
                return-object
                clearable
                @change="selectedModuleChanged"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-checkbox
                v-model="assign.assignToAll"
                label="Assign to All"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="8">
              <assign-dropdown
                :value="assign.user_ids"
                :set-drop-down-value="setDropdownValue"
              ></assign-dropdown>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="assign.group_ids"
                :items="groups"
                item-text="name"
                item-value="id"
                :menu-props="{ closeOnClick: true }"
                label="Search groups"
                multiple
                append-icon=""
                prepend-icon="fal fa-user-friends"
              >
                <template v-slot:selection="{ item }">
                  <v-chip :small="assign.group_ids.length >= 4">
                    <span>{{ item.name }}</span>
                  </v-chip>
                </template>

                <template v-if="canUpdateCreateGroup" v-slot:prepend-item>
                  <v-list-item ripple @click="createNewGroup()">
                    <v-list-item-content>
                      <v-list-item-title
                        style="
                          font-size: 17px;
                          display: flex;
                          justify-content: center;
                          gap: 7px;
                          align-items: center;
                        "
                      >
                        <i class="fas fa-plus"></i>
                        <span>Create New Group</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>

                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                    <v-list-item-action>
                      <v-checkbox :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-row no-gutters align="center">
                        <span>{{ item.name }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="canUpdateCreateGroup"
                          icon
                          large
                          v-on:click.stop="editGroup(item)"
                        >
                          <v-icon small>fal fa-edit</v-icon>
                        </v-btn>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-menu
                    ref="dueDateMenu"
                    v-model="dueDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="assign.due_date"
                        label="Due Date"
                        persistent-hint
                        prepend-icon="fal fa-calendar"
                        v-bind="attrs"
                        readonly
                        @blur="date = parseDate(assign.due_date)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="dueDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <div class="d-flex" style="padding-top: 20px">
                    <i class="fal fa-clock" style="padding-right: 10px"></i>
                    <div>
                      <flat-pickr
                        :config="configs.timePicker"
                        class="time-picker"
                        v-model="time.value"
                        placeholder="Time"
                        name="time"
                      >
                      </flat-pickr>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <div class="d-flex" style="font-size: 1.4rem; color: #5b5a5a">
                <i class="fal fa-paper-plane"></i>
                <div>
                  <span style="padding: 10px">Send Notification thru</span>
                </div>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="ml-6">
                  <v-checkbox
                    v-model="assign.notifyBy"
                    label="Text"
                    color="blue darken-3"
                    value="Text"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="ml-6">
                  <v-checkbox
                    v-model="assign.notifyBy"
                    label="Email"
                    color="blue darken-3"
                    value="Email"
                    hide-details
                    style="margin-top: 0 !important"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="loading"
          text
          @click="assignModule"
          >Save</v-btn
        >
        <v-btn
          color="blue-grey"
          :loading="loading"
          :disabled="loading"
          text
          @click="close"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {
  each as _each,
  findIndex as _findIndex,
  map as _map,
  union as lodashUnion,
} from 'lodash-es';
import AssignDropdown from '../../client-lms/AssignDropdown.vue';
import AddEditGroupsDialog from '@/components/user-management/user/partial/AddNewGroupDialog.vue';
import { canUpdateCreateGroups } from './../../../helper/user/roleHelper';

export default {
  name: 'ToolbarAssignModules',
  components: {
    AssignDropdown,
    AddEditGroupsDialog,
  },

  props: {
    value: Boolean,
  },

  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      assign: {
        assignToAll: false,
        due_date: this.formatDate(new Date().toISOString().substr(0, 10)),
        module_id: null,
        user_ids: [],
        group_ids: [],
        time: null,
        notifyBy: ['Text', 'Email'],
      },
      dueDateMenu: false,
      loading: false,
      groups: [],
      selectedUsers: [],
      usersSearchResult: [],
      modulesSearchResult: [],
      selectedModule: null,
      searchModules: null,
      selectLoading: {
        users: true,
      },
      configs: {
        basic: {},
        timePicker: {
          wrap: true,
          enableTime: true,
          enableSeconds: false,
          noCalendar: true,
        },
      },
      time: {
        value: '09:00:00',
        type: 'string',
      },
      notifOption: ['Text', 'Email'],
    };
  },

  computed: {
    canUpdateCreateGroup() {
      return canUpdateCreateGroups(this.$auth.user().roles);
    },
    showAssignModule: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    salesPersons() {
      return this.$store.state.lmsClient.listUsers;
    },
    showSelectedUsers() {
      return this.selectedUsers.length > 0;
    },
    modules() {
      return lodashUnion(this.assign.module_id, this.modulesSearchResult);
    },
  },

  created() {
    this.getFirstTenUsers();
    this.getTenModules();
    this.getGroups();
  },

  methods: {
    getTenModules() {
      this.$http
        .get('/lms-manager/fetch/assignmodules')
        .then(({ data }) => {
          const list = data.data;
          list.map((item) => (item.checked = false));
          this.modulesSearchResult = list;
        })
        .catch(() => {
          console.log('Error loading the units. Please try again');
        });
    },
    selectedModuleChanged() {
      this.searchModules = '';

      if (!this.searchModules.length) {
        this.getTenModules();
      }
    },
    setDropdownValue(value) {
      this.assign.user_ids = value;
    },
    getFirstTenUsers() {
      this.selectLoading.users = true;
      this.$http
        .get('get-random-users', {
          params: {
            users: 10,
          },
        })
        .then(({ data }) => {
          _each(data, (user) => {
            const index = _findIndex(this.usersSearchResult, { id: user.id });
            if (index === -1) {
              this.usersSearchResult.push(user);
            }
          });
          this.selectLoading.users = false;
        })
        .catch((error) => {
          this.selectLoading.users = false;
        });
    },
    getGroups() {
      console.log('get groups');
      this.$http
        .get('/groups')
        .then((response) => {
          _each(response.data, (group) => {
            this.groups.push(group);
          });
        })
        .catch((err) => {});
    },

    assignModule() {
      this.loading = true;
      this.assign.time = this.time.value;
      if (this.assign.user_ids.length < 1 && this.assign.group_ids.length < 1) {
        this.$notify('error', 'No User/Group selected');
        this.loading = true;
      } else {
        this.assign.user_ids = _map(this.assign.user_ids, (user) => {
          return user.id;
        });
        this.assign.module_id = this.assign.module_id.id;
        this.$store
          .dispatch('lmsClient/assignModule', this.assign)
          .then(({ data }) => {
            this.$notify('success', 'Module Assigned to User(s) successfully');
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
            this.close();
          });
      }
    },

    close() {
      const def = {
        module_id: this.module_id,
        user_ids: [],
        assignToAll: false,
        due_date: this.formatDate(new Date().toISOString().substr(0, 10)),
        notifyBy: ['Text', 'Email'],
      };
      this.assign = def;
      this.showAssignModule = false;
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    loadModules(filter) {
      const params = {};
      if (filter) {
        params.filter = filter;
      }

      this.$http
        .get('/lms-manager/fetch/assignmodules', { params })
        .then(({ data }) => {
          const list = data.data;

          list.map((item) => (item.checked = false));

          this.modulesSearchResult = list;
        })
        .catch(() => {
          console.log('Error loading the units. Please try again');
        });
    },
    editGroup(group) {
      this.hideMenuContentWhenOpeningNewDialog();
      this.$refs['addEditGroupInDialog'].toggleDialog('Edit Group', group);
    },
    hideMenuContentWhenOpeningNewDialog() {
      let el = document.getElementsByClassName('menuable__content__active');
      el[0].classList.add('display-none');
    },
    createNewGroup() {
      this.hideMenuContentWhenOpeningNewDialog();
      this.$refs['addEditGroupInDialog'].toggleDialog(
        'Create New Group',
        false
      );
    },
    doneNewGroup(item) {
      if (item.isUpdate) {
        let indexToModify = this.groups.findIndex(
          (group) => group.id === item.id
        );
        if (indexToModify > -1) {
          this.groups[indexToModify].name = item.name;
        }

        if (!this.assign.group_ids.includes(item.id)) {
          this.assign.group_ids.push(item.id);
        }
      } else {
        if (item) this.groups.push(item);
        if (item.id) this.assign.group_ids.push(item.id);
      }
    },
  },

  watch: {
    date(val) {
      this.assign.due_date = this.formatDate(this.date);
    },
    searchModules(val) {
      if (val) {
        this.loadModules(val);
      }
    },
  },
};
</script>
<style>
.time-picker {
  border: none !important;
  border-bottom: 1px solid !important;
  border-radius: 0 !important;
  font-size: 1.2rem !important;
  width: 93% !important;
  padding: 4px !important;
  color: black !important;
}
.fa-clock:before {
  font-size: 2rem !important;
}
</style>

<style scoped>
@media only screen and (max-width: 600px) {
  .headline {
    font-size: 10px !important;
  }
}
</style>
